import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAppScreens, LazyAppStoreButton, LazyCookie, LazyDownloadAppStore, LazyDownloadPlayStore, LazyFAQItem, LazyFeatureAchievements, LazyFeatureAnalyse, LazyFeatureBuddy, LazyFeatureChallenge, LazyFeatureCraving, LazyFeatureHealth, LazyFeatureMilestones, LazyFeatureSavings, LazyFeatureSuperPower, LazyFooter, LazyHeader, LazyIconFacebook, LazyIconInstagram, LazyIconLinkedin, LazyIconTwitter, LazyInstructionStep, LazyIntersection, LazyNavigation, LazyNewsletterForm, LazyPlayStoreButton, LazyPostCategories, LazyPostItem, LazyPostItemFeatured, LazyPrivacySection, LazyShare, LazySmoxyLogoType, LazyStoreRating, LazySubscribeForm, LazyTermsItem, LazyAuthor, LazyConclusion, LazyFeature, LazyGrid, LazyGrid2, LazyListTile, LazyPage, LazyPost, LazyReferenceItem, LazySectionIntro, LazySectionTitleBody, LazyStepItem, LazySteps, LazyTeaser, LazyWrapList, LazyCategory, LazyCookieClientOnlyPrerender, LazyCookieControl, LazyCookieIframe } from '#components'
const lazyGlobalComponents = [
  ["AppScreens", LazyAppScreens],
["AppStoreButton", LazyAppStoreButton],
["Cookie", LazyCookie],
["DownloadAppStore", LazyDownloadAppStore],
["DownloadPlayStore", LazyDownloadPlayStore],
["FAQItem", LazyFAQItem],
["FeatureAchievements", LazyFeatureAchievements],
["FeatureAnalyse", LazyFeatureAnalyse],
["FeatureBuddy", LazyFeatureBuddy],
["FeatureChallenge", LazyFeatureChallenge],
["FeatureCraving", LazyFeatureCraving],
["FeatureHealth", LazyFeatureHealth],
["FeatureMilestones", LazyFeatureMilestones],
["FeatureSavings", LazyFeatureSavings],
["FeatureSuperPower", LazyFeatureSuperPower],
["Footer", LazyFooter],
["Header", LazyHeader],
["IconFacebook", LazyIconFacebook],
["IconInstagram", LazyIconInstagram],
["IconLinkedin", LazyIconLinkedin],
["IconTwitter", LazyIconTwitter],
["InstructionStep", LazyInstructionStep],
["Intersection", LazyIntersection],
["Navigation", LazyNavigation],
["NewsletterForm", LazyNewsletterForm],
["PlayStoreButton", LazyPlayStoreButton],
["PostCategories", LazyPostCategories],
["PostItem", LazyPostItem],
["PostItemFeatured", LazyPostItemFeatured],
["PrivacySection", LazyPrivacySection],
["Share", LazyShare],
["SmoxyLogoType", LazySmoxyLogoType],
["StoreRating", LazyStoreRating],
["SubscribeForm", LazySubscribeForm],
["TermsItem", LazyTermsItem],
["Author", LazyAuthor],
["Conclusion", LazyConclusion],
["Feature", LazyFeature],
["Grid", LazyGrid],
["Grid2", LazyGrid2],
["ListTile", LazyListTile],
["Page", LazyPage],
["Post", LazyPost],
["ReferenceItem", LazyReferenceItem],
["SectionIntro", LazySectionIntro],
["SectionTitleBody", LazySectionTitleBody],
["StepItem", LazyStepItem],
["Steps", LazySteps],
["Teaser", LazyTeaser],
["WrapList", LazyWrapList],
["Category", LazyCategory],
["CookieClientOnlyPrerender", LazyCookieClientOnlyPrerender],
["CookieControl", LazyCookieControl],
["CookieIframe", LazyCookieIframe],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
